import LoadingProgressTutorial from '@core/dashboard/components/LoadingProgressTutorial';
import AppLoader from '@core/dashboard/components/AppLoader';

import { useCoreWeaveProgressBar } from './hooks';

const CoreWeaveLoader = () => {
  const {
    secondStepLoading,
    secondStepCompleted,
    thirdStepLoading,
    thirdStepCompleted,
    forthStepLoading,
    forthStepCompleted,
  } = useCoreWeaveProgressBar();

  return (
    <AppLoader>
      <LoadingProgressTutorial
        secondStepLoading={secondStepLoading}
        secondStepCompleted={secondStepCompleted}
        thirdStepLoading={thirdStepLoading}
        thirdStepCompleted={thirdStepCompleted}
        forthStepLoading={forthStepLoading}
        forthStepCompleted={forthStepCompleted}
      />
    </AppLoader>
  );
};

export default CoreWeaveLoader;
